export default __webpack_public_path__ + "static/media/28mmbrownplain.6efca152.jpg";